import { Box } from '@mui/material'
import { useQuery } from '@tanstack/react-query' // o 'react-query' dependiendo de tu versión
import { MRT_Header } from 'material-react-table'
import React from 'react'

import FormSelect from '../../../base/components/Form/FormSelect.tsx'
import { PreloadFieldSkeleton } from '../../../base/components/skeleton/PreloadFieldSkeleton.tsx'
import { ArticuloProps } from '../../../interfaces/articulo.ts'
import { TipoArticuloProps } from '../../../interfaces/tipoArticulo.ts'
import { apiTipoArticuloSimpleListado } from '../../tipoArticulo/api/apiTipoArticuloSimpleListado.ts'

interface TipoArticuloFilterProps {
  column: MRT_Header<ArticuloProps>['column']
}

/**
 * Filtro de tipo articulo para listado de articulos
 * @param param0
 * @param param0.column
 * @constructor
 */
export const MrtTipoArticuloFilter = ({ column }: TipoArticuloFilterProps) => {
  // Implementación de React Query
  const { data: options = [], isLoading } = useQuery({
    queryKey: ['tipos-articulo-catalogo'],
    queryFn: async () => {
      return apiTipoArticuloSimpleListado(100)
    },
  })

  // Recuperamos el valor actual del filtro (el _id)
  const filterValue = column.getFilterValue() as string | undefined

  // Encontramos el objeto completo que corresponde al _id filtrado
  const value = options.find((opt) => opt._id === filterValue) || null

  return (
    <Box zIndex={999999} onKeyDown={(e) => e.stopPropagation()}>
      <PreloadFieldSkeleton isLoading={isLoading}>
        <FormSelect<TipoArticuloProps>
          id={'filtro-tipo-articulo'}
          menuPosition={'fixed'}
          menuPortalTarget={document.body}
          placeholder={'Filtrar...'}
          options={options}
          value={value}
          onChange={(newValue) => {
            column.setFilterValue(newValue ? newValue._id : undefined)
          }}
          getOptionLabel={(option) => option.descripcion}
          getOptionValue={(option) => option._id}
          isClearable={true}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 999999 }),
          }}
        />
      </PreloadFieldSkeleton>
    </Box>
  )
}
